module.exports = __webpack_public_path__ + "img/cloudview_games-menu.aebc25ca.jpg";